import {
  CampaignLinkCellRenderer,
  CreatorLinkCellRenderer,
} from "components/DataGrid/components";
import { BrandLinkCellRenderer } from "components/DataGrid/components/LinkCellRenderers/BrandLinkCellRenderer";

export const documentColDefs = [
  {
    headerName: "_id",
    field: "_id",
    hide: true,
  },
  {
    headerName: "Title",
    field: "title",
    flex: 2,
  },
  {
    headerName: "Creator",
    field: "user_id",
    valueGetter: (params) => params.data?.user_id?._id || params.data?.user_id,
    cellRenderer: CreatorLinkCellRenderer,
    valueFormatter: (params) => params.data?.user_id?.name || "",
    filterValueGetter: (params) => {
      const user = params.data?.user_id;
      return user ? `${user.name} ${user._id}` : "";
    },
    flex: 1.5,
  },
  {
    headerName: "Campaign",
    field: "campaign_id",
    cellRenderer: CampaignLinkCellRenderer,
    valueGetter: (params) =>
      params.data?.campaign_id?._id || params.data?.campaign_id,
    valueFormatter: (params) => params.data?.campaign_id?.name || "",
    filterValueGetter: (params) => {
      const campaign = params.data?.campaign_id;
      return campaign ? `${campaign.name} ${campaign._id}` : "";
    },
    flex: 1.5,
  },
  {
    headerName: "Created",
    field: "created",
    type: "date",
    flex: 1,
  },
  {
    headerName: "Updated",
    field: "updated",
    type: "date",
    flex: 1,
    sort: "desc",
  },
];
